import React from "react";

import Migracion from "./migracion/routes";
import Information from "./information";
import Setting from "./setting";

import { Switch, Route, Redirect } from "react-router-dom";

import {
    LAYOUT_ADMIN_CONFIG_SETTING,
    LAYOUT_ADMIN_CONFIG_MIGRATION,
    LAYOUT_ADMIN_CONFIG_INFORMATION,
} from "../navigation";

const Router = (props) => (
    <Switch>
        <Route path={LAYOUT_ADMIN_CONFIG_MIGRATION} render={(routeProps) => <Migracion {...props} {...routeProps} />} />
        <Route
            path={LAYOUT_ADMIN_CONFIG_INFORMATION}
            render={(routeProps) => <Information {...props} {...routeProps} />}
        />
        <Route path={LAYOUT_ADMIN_CONFIG_SETTING} render={(routeProps) => <Setting {...props} {...routeProps} />} />
        <Redirect to={"/"} />
    </Switch>
);

export default Router;
